// extracted by mini-css-extract-plugin
export default {"data_box":"index_data_box_7-9V-","price":"index_price_sdTZk","green":"index_green_V02uz","up":"index_up_-VHx3","down":"index_down_np2K-"};